import React from "react";
import DataFormItem from "../../DataForm/src/DataFormItem";
// import { SEARCH_FORM_TRIGGER_MAP } from "./CONFIG";
const SearchFormItem = (props: unknown) => {
  // const { inputType } = props;
  return (
    <DataFormItem
      {...props}
    />
  );
};
export default SearchFormItem;
